// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_API_KEY,
//     authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_APP_ID,
//   };
//   export default firebaseConfig;


/// i tried and spend many hours but did not work with me.

  const firebaseConfig = {
    apiKey: "AIzaSyAdZof-QG49w3YxQ4ROtKHY2k867z23a60",
    authDomain: "wellness-shop.firebaseapp.com",
    projectId: "wellness-shop",
    storageBucket: "wellness-shop.appspot.com",
    messagingSenderId: "529920173318",
    appId: "1:529920173318:web:abfc18453779da1a722a87"
  };
  export default firebaseConfig;